
class BatchRequestsQueue {
  constructor () {
    this.requestsQueue = [];
  }

  enqueue (batchRequestItem) {
    this.requestsQueue.push(batchRequestItem);
  }

  dequeueAll () {
    const items = this.requestsQueue;
    this.requestsQueue = [];

    return items;
  }
}

export default BatchRequestsQueue;
